<template>
  <div>
    <van-popup
      v-model="visible"
      :closeable="false"
      :close-icon="closeIcon"
      @click-overlay="handleClickOverlay"
      @close="handleClose"
      class="login-popup"
    >
      <!-- Close Button -->
      <button class="login-popup__close" @click="logClose">
        <van-icon name="cross" size="18" color="rgba(255,255,255,0.5)" />
      </button>

      <!-- Header Image -->
      <div class="login-popup__banner">
        <img
          class="login-popup__banner-img"
          src="../assets/img/sign_in/header.jpg"
          alt="VUKAVI"
        />
        <span class="login-popup__banner-welcome">{{ $lang.login_welcome || 'WELCOME TO VUKAVI' }}</span>
      </div>

      <!-- Tab Switcher -->
      <div class="login-popup__tabs">
        <div
          class="login-popup__tab"
          :class="{ 'login-popup__tab--active': selectIndex === 0 }"
          @click="selectTab(0)"
        >
          {{ $lang.Entrar || 'Sign In' }}
        </div>
        <div
          class="login-popup__tab"
          :class="{ 'login-popup__tab--active': selectIndex === 1 }"
          @click="selectTab(1)"
        >
          {{ $lang.Registro || 'Register' }}
        </div>
      </div>

      <!-- Form -->
      <div class="login-popup__form">
        <!-- Phone Input -->
        <div class="login-popup__field-row" style="position: relative;">
          <div class="login-popup__area-code" @click="isSingleCountry ? null : getLangT">
            <img :src="selectedIcon || GET_ICONURL" width="22" />
            <span class="login-popup__area-code-text">{{ selectedAreaCode || GET_AREACODE }}</span>
            <van-icon v-if="!isSingleCountry" :name="showCountryDrop ? 'arrow-up' : 'arrow-down'" size="10" color="var(--vk-t2)" />
          </div>
          <!-- Country Dropdown -->
          <div v-if="showCountryDrop && !isSingleCountry" class="login-popup__dropdown">
            <div
              v-for="(item, idx) in countryList"
              :key="idx"
              class="login-popup__dropdown-item"
              @click="selectCountry(item)"
            >
              <img :src="item.iconUrl" width="24" />
              <span>{{ item.countryName }}</span>
              <span class="login-popup__dropdown-code">{{ item.areaCode }}</span>
            </div>
            <div v-if="countryList.length === 0" class="login-popup__dropdown-item" style="justify-content: center; color: var(--vk-t3);">
              {{ $lang.common_loading || 'Loading...' }}
            </div>
          </div>
          <van-field
            v-model="account"
            :placeholder="$lang.login_txt || 'Enter mobile number'"
            class="login-popup__input"
            :class="{ 'login-popup__input--focus': isFocused, 'login-popup__input--error': vError1 }"
            @focus="isFocused = true"
            @blur="isFocused = false"
            :update:model-value="(account = account.replace(/\D/g, '').slice(0, 13))"
            @input="getError3"
            type="number"
          />
        </div>
        <p v-if="vError1" class="login-popup__error">
          <van-icon name="warning" color="var(--vk-danger)" size="12" /> {{ vError1 }}
        </p>

        <!-- Captcha (Register + GHS only) -->
        <div v-if="selectIndex === 1 && isGhsCurrency" class="login-popup__field">
          <van-field
            v-model="captcha"
            :placeholder="$lang.login_captcha_placeholder || 'Enter verification code'"
            class="login-popup__input login-popup__input--captcha"
            :class="{ 'login-popup__input--focus': isFocusedCaptcha, 'login-popup__input--error': vErrorCaptcha }"
            @focus="isFocusedCaptcha = true"
            @blur="isFocusedCaptcha = false"
            :update:model-value="(captcha = captcha.replace(/\s+/g, ''))"
            @input="getCaptchaError"
          >
            <template #button>
              <span
                class="login-popup__captcha-send"
                :class="{ 'login-popup__captcha-send--disabled': !canSendCaptcha }"
                @click="sendCaptcha"
              >
                {{ captchaCountdown > 0 ? `${captchaCountdown}s` : ($lang.login_captcha_send || 'Send') }}
              </span>
            </template>
          </van-field>
        </div>
        <p v-if="selectIndex === 1 && isGhsCurrency && vErrorCaptcha" class="login-popup__error">
          <van-icon name="warning" color="var(--vk-danger)" size="12" /> {{ vErrorCaptcha }}
        </p>

        <!-- Password -->
        <div class="login-popup__field">
          <van-field
            v-model="passwd"
            :placeholder="$lang.login_txt4 || 'Password'"
            class="login-popup__input login-popup__input--icon"
            :class="{ 'login-popup__input--focus': isFocused2, 'login-popup__input--error': vError2 }"
            @focus="isFocused2 = true"
            @blur="isFocused2 = false"
            :type="isShowMm ? 'text' : 'password'"
            :update:model-value="(passwd = passwd.replace(/\s+/g, ''))"
            @input="getError"
          >
            <template #left-icon>
              <van-icon name="lock" size="18" color="var(--vk-t2)" />
            </template>
            <template #right-icon>
              <van-icon
                :name="isShowMm ? 'eye-o' : 'closed-eye'"
                size="18"
                color="var(--vk-t2)"
                @click="isShowMm = !isShowMm"
              />
            </template>
          </van-field>
        </div>
        <p v-if="vError2" class="login-popup__error">
          <van-icon name="warning" color="var(--vk-danger)" size="12" /> {{ vError2 }}
        </p>

        <!-- Confirm Password (Register only) -->
        <div v-if="selectIndex === 1" class="login-popup__field">
          <van-field
            v-model="conPasswd"
            :placeholder="$lang.login_txt6 || 'Confirm your password'"
            class="login-popup__input login-popup__input--icon"
            :class="{ 'login-popup__input--focus': isFocused3, 'login-popup__input--error': vError3 }"
            @focus="isFocused3 = true"
            @blur="isFocused3 = false"
            :type="isShowMm2 ? 'text' : 'password'"
            :update:model-value="(conPasswd = conPasswd.replace(/\s+/g, ''))"
            @input="getError2"
          >
            <template #left-icon>
              <van-icon name="lock" size="18" color="var(--vk-t2)" />
            </template>
            <template #right-icon>
              <van-icon
                :name="isShowMm2 ? 'eye-o' : 'closed-eye'"
                size="18"
                color="var(--vk-t2)"
                @click="isShowMm2 = !isShowMm2"
              />
            </template>
          </van-field>
        </div>
        <p v-if="selectIndex === 1 && vError3" class="login-popup__error">
          <van-icon name="warning" color="var(--vk-danger)" size="12" /> {{ vError3 }}
        </p>

        <!-- Submit Button -->
        <button
          class="login-popup__submit"
          :class="{ 'login-popup__submit--disabled': !isBtnEnable }"
          :disabled="!isBtnEnable"
          @click="LoginBtn"
        >
          {{ selectIndex === 0 ? ($lang.Entrar || 'Sign In') : ($lang.Registro || 'Register') }}
        </button>

        <!-- Agreement Checkbox -->
        <div class="login-popup__agree">
          <van-checkbox
            v-model="agree"
            shape="square"
            checked-color="#ff5a1f"
            icon-size="14px"
          >
            <span class="login-popup__agree-text">{{ $lang.common_txt271 || 'Agree or disagree with the Service Policy and Privacy Policy' }}</span>
          </van-checkbox>
        </div>

        <!-- Google Divider -->
        <div class="login-popup__divider">
          <span class="login-popup__divider-line"></span>
          <span class="login-popup__divider-text">{{ $lang.login_txt12 || 'OR' }}</span>
          <span class="login-popup__divider-line"></span>
        </div>

        <!-- Google Login -->
        <button class="login-popup__google" @click="handleGoogleLogin" :disabled="googleLoading">
          <svg viewBox="0 0 48 48" width="18" height="18">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#FBBC05" d="M10.53 28.59A14.5 14.5 0 0 1 9.5 24c0-1.59.28-3.14.76-4.59l-7.98-6.19A23.99 23.99 0 0 0 0 24c0 3.77.9 7.35 2.56 10.52l7.97-5.93z"/>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 5.93C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          <span>{{ $lang.google_login || 'Sign in with Google' }}</span>
        </button>

        <!-- 负责任博彩固定尾注(品牌合规必带) -->
        <p class="login-popup__responsible">
          {{ $lang.responsible_footer || '18+ · Play responsibly' }}
        </p>
      </div>
    </van-popup>

    <!-- Google Registration Popup -->
    <van-popup
      v-model="showGoogleRegister"
      :closeable="true"
      close-icon="cross"
      round
      class="google-reg-popup"
    >
      <div class="google-reg">
        <h3 class="google-reg__title">{{ $lang.google_register_title || 'Complete Registration' }}</h3>
        <div class="login-popup__field-row" style="position: relative;">
          <div class="login-popup__area-code" @click="isSingleCountry ? null : getLangT">
            <img :src="selectedIcon || GET_ICONURL" width="22" />
            <span class="login-popup__area-code-text">{{ selectedAreaCode || GET_AREACODE }}</span>
            <van-icon v-if="!isSingleCountry" name="arrow-down" size="10" color="var(--vk-t2)" />
          </div>
          <div v-if="showCountryDrop && !isSingleCountry" class="login-popup__dropdown">
            <div
              v-for="(item, idx) in countryList"
              :key="idx"
              class="login-popup__dropdown-item"
              @click="selectCountry(item)"
            >
              <img :src="item.iconUrl" width="24" />
              <span>{{ item.countryName }}</span>
              <span class="login-popup__dropdown-code">{{ item.areaCode }}</span>
            </div>
            <div v-if="countryList.length === 0" class="login-popup__dropdown-item" style="justify-content: center; color: var(--vk-t3);">
              {{ $lang.common_loading || 'Loading...' }}
            </div>
          </div>
          <van-field
            v-model="googlePhoneNo"
            :placeholder="$lang.google_register_phone || 'Enter phone number'"
            class="login-popup__input"
            :update:model-value="(googlePhoneNo = googlePhoneNo.replace(/\D/g, '').slice(0, 13))"
            type="number"
          />
        </div>
        <p v-if="googleRegError" class="login-popup__error">
          <van-icon name="warning" color="var(--vk-danger)" size="12" /> {{ googleRegError }}
        </p>
        <button
          class="login-popup__submit"
          :disabled="!googlePhoneNo || googleRegLoading"
          :class="{ 'login-popup__submit--disabled': !googlePhoneNo }"
          @click="handleGoogleRegister"
        >
          {{ $lang.Registro || 'Register' }}
        </button>
      </div>
    </van-popup>

    <Vcode
      :show="isShow"
      @success="success"
      @close="close2"
      :successText="$lang.login_txt13"
      :failText="$lang.login_txt14"
      :sliderText="$lang.login_txt15"
      style="z-index: 9999999"
    />
  </div>
</template>

<script>
import { isNavigationFailure, NavigationFailureType } from 'vue-router'
import Vcode from 'vue-puzzle-vcode'

import { Login, Register, GetIsFbReport, GetInvitationID, GetPlatformList, GetGoogleAuthorizingUrl, GoogleRegister, GetCaptcha } from '@/api/common'
import { SINGLE_COUNTRY } from '@/config/singleCountry'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'
import { safeGetStorageItem, safeLocalStorage, safeRemoveStorageItem, safeSessionStorage, safeSetStorageItem } from '@/utils/safeStorage'
import {
  accessTokenOf,
  contentOf,
  failMessage,
  googleRedirectUrl,
  isNeedLogin,
  isOkResponse,
  normalizePlatform,
  normalizePlatformList,
  safeString,
  safeTrackCompleteRegistration
} from '@/utils/h5AuthFlow'
import md5 from 'md5'
const POST_LOGIN_REDIRECT_KEY = 'otgame_postLoginRedirect'

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) { return null }
  return null
}

function getSessionStorage() {
  try {
    if (typeof safeSessionStorage === 'function') return safeSessionStorage()
  } catch (e) { return null }
  return null
}

function reloadLocationSafely() {
  try {
    if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
      window.location.reload()
      return true
    }
  } catch (e) {
    return false
  }
  return false
}

function getBrowserWindow() {
  try {
    return typeof window === 'undefined' ? null : window
  } catch (e) {
    return null
  }
}

function getBrowserLocation() {
  try {
    const browserWindow = getBrowserWindow()
    return browserWindow && browserWindow.location ? browserWindow.location : null
  } catch (e) {
    return null
  }
}

function browserLocationValue(key) {
  try {
    const location = getBrowserLocation()
    const value = location && location[key]
    return typeof value === 'string' ? value : ''
  } catch (e) {
    return ''
  }
}

function getLocationOrigin() {
  return browserLocationValue('origin')
}

function googleCallbackOrigin(origin) {
  if (origin === 'http://127.0.0.1:8080' || origin === 'http://localhost:8080') {
    return 'http://localhost:8080'
  }
  return origin
}

function googleCallbackRedirectUri() {
  const origin = getLocationOrigin()
  if (!origin) return ''
  try {
    return new URL('/api/auth/google/callback', googleCallbackOrigin(origin)).toString()
  } catch (e) {
    return googleCallbackOrigin(origin) + '/api/auth/google/callback'
  }
}

function getLocationHref() {
  return browserLocationValue('href')
}

function browserDocumentTitle() {
  try {
    return typeof document !== 'undefined' && document ? document.title : ''
  } catch (e) {
    return ''
  }
}

function redirectBrowserTo(url) {
  try {
    const location = getBrowserLocation()
    if (!location || !url) return false
    location.href = url
    return true
  } catch (e) {
    return false
  }
}

function replaceBrowserHistory(url) {
  try {
    const browserWindow = getBrowserWindow()
    const history = browserWindow && browserWindow.history
    if (!history || typeof history.replaceState !== 'function') return false
    const title = browserDocumentTitle()
    history.replaceState({}, title, url)
    return true
  } catch (e) {
    return false
  }
}

async function asheLocalPasswordHash(account, password) {
  try {
    const browserWindow = getBrowserWindow()
    const TextEncoderCtor = browserWindow && browserWindow.TextEncoder
    const subtle = browserWindow && browserWindow.crypto && browserWindow.crypto.subtle
    if (!browserWindow || !subtle || typeof subtle.digest !== 'function' || typeof TextEncoderCtor !== 'function') {
      return ''
    }
    const source = `ashe|${account || ''}|${password || ''}`
    const digest = await subtle.digest('SHA-256', new TextEncoderCtor().encode(source))
    return Array.from(new Uint8Array(digest)).map(item => item.toString(16).padStart(2, '0')).join('')
  } catch (e) {
    return ''
  }
}

function isIgnoredLoginRedirectNavigationFailure(error) {
  if (isNavigationFailure && NavigationFailureType) {
    const ignoredTypes = [
      NavigationFailureType.duplicated,
      NavigationFailureType.cancelled,
      NavigationFailureType.aborted
    ].filter(Boolean)
    if (ignoredTypes.some(type => isNavigationFailure(error, type))) return true
  }

  const legacyNavigationDuplicatedName = 'NavigationDuplicated'
  const name = safeString(error && error.name).toLowerCase()
  const message = safeString(error && error.message).toLowerCase()
  return (
    name === legacyNavigationDuplicatedName.toLowerCase() ||
    message.includes('navigationduplicated') ||
    message.includes('duplicated') ||
    message.includes('cancelled') ||
    message.includes('aborted')
  )
}

export default {
  components: { Vcode },
  name: 'Login',
  props: {
    // 控制弹窗显示的布尔值
    value: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    closeable: {
      type: Boolean,
      default: false
    },
    // 关闭按钮的图标
    closeIcon: {
      type: String,
      default: 'cross'
    },
    // 是否显示遮罩层
    overlay: {
      type: Boolean,
      default: true
    },
    loginType: {
      type: Number,
      default: 0
    }
  },
  data() {
    const localStorage = getLocalStorage()
    return {
      isSingleCountry: !!SINGLE_COUNTRY,
      showCountryDrop: false,
      countryList: [],
      selectedIcon: safeGetStorageItem(localStorage, 'iconUrl'),
      selectedAreaCode: safeGetStorageItem(localStorage, 'areaCode'),
      isShow: false,
      isShowMm: false,
      isShowMm2: false,
      agree: true,
      agree2: true,
      vError1: '',
      vError2: '',
      vError3: '',
      vErrorCaptcha: '',
      isFocused: false, // 用于标记是否聚焦
      isFocused2: false, // 用于标记是否聚焦
      isFocused3: false,
      isFocusedCaptcha: false,
      account: '',
      passwd: '',
      conPasswd: '',
      captcha: '',
      captchaCountdown: 0,
      captchaTimer: null,
      isCaptchaSending: false,
      isLogin: true,
      visible: this.value, // 内部状态
      registerParames: {},
      selectIndex: 0,
      submitting: false,
      // Google login
      googleLoading: false,
      showGoogleRegister: false,
      googlePhoneNo: '',
      googleThirdUuid: safeGetStorageItem(localStorage, 'googleThirdUuid'),
      googleRegError: '',
      googleRegLoading: false
    }
  },
  // 新增：计算按钮是否可点击
  computed: {
    isGhsCurrency() {
      const localStorage = getLocalStorage()
      return safeGetStorageItem(localStorage, 'currency') === 'GHS'
    },
    canSendCaptcha() {
      return !this.isCaptchaSending && this.captchaCountdown === 0
    },
    isBtnEnable() {
      if (this.selectIndex === 0) {
        // 登录标签页：账号(8-13位数字)/密码非空 + 无错误提示
        return (
          /^\d{8,13}$/.test(this.account) &&
          this.passwd &&
          !this.submitting &&
          !this.vError1 &&
          !this.vError2
        )
      } else {
        // 注册标签页：账号(8-13位数字)/密码/确认密码非空 + 无错误提示 + 同意协议
        const baseEnable = (
          /^\d{8,13}$/.test(this.account) &&
          this.passwd &&
          this.conPasswd &&
          !this.vError1 &&
          !this.vError2 &&
          !this.vError3 &&
          this.agree &&
          !this.submitting
        )

        if (this.isGhsCurrency) {
          return baseEnable && this.captcha && !this.vErrorCaptcha
        }

        return baseEnable
      }
    }
  },
  watch: {
    // 监听外部传入的 value 值变化
    value(newVal) {
      this.visible = newVal
    },
    // 监听内部 visible 值变化，同步到外部
    visible(newVal) {
      this.$emit('input', newVal)
      if (newVal) {
        this.selectTab(this.loginType)
        this.GetInvitationID()
      }
    }
  },
  mounted() {
    // Google callback is handled by App.vue (checkGoogleCallback)
  },
  methods: {
    currentAreaCode() {
      const localStorage = getLocalStorage()
      return safeString(this.selectedAreaCode || this.GET_AREACODE || safeGetStorageItem(localStorage, 'areaCode'))
    },
    currentCurrency() {
      const localStorage = getLocalStorage()
      return safeString(this.getCurrency || safeGetStorageItem(localStorage, 'currency'))
    },
    currentPlatform() {
      const localStorage = getLocalStorage()
      return safeString(this.GET_PLATFORM || safeGetStorageItem(localStorage, 'platform'))
    },
    async GetInvitationID() {
      const localStorage = getLocalStorage()
      try {
        const data = await GetInvitationID({
          inviteCode: safeGetStorageItem(localStorage, 'id')
        })
        if (!isOkResponse(data) || isNeedLogin(data)) return
        const content = contentOf(data)
        if (content.invitCode) {
          safeSetStorageItem(localStorage, 'id', content.invitCode)
        }
      } catch (e) {
        // Keep login usable when invite lookup is unavailable.
      }
    },
    getLangT() {
      this.showCountryDrop = !this.showCountryDrop
      if (this.showCountryDrop && this.countryList.length === 0) {
        this.fetchCountryList()
      }
    },
    async fetchCountryList() {
      try {
        const data = await GetPlatformList()
        this.countryList = isOkResponse(data) && !isNeedLogin(data)
          ? normalizePlatformList(data)
          : []
      } catch (e) {
        this.countryList = []
      }
    },
    selectCountry(item) {
      const platform = normalizePlatform(item)
      if (!platform.areaCode && !platform.country && !platform.platform) {
        this.showCountryDrop = false
        return
      }
      const localStorage = getLocalStorage()
      const prevPlatform = safeGetStorageItem(localStorage, 'platform')
      if (platform.platform) {
        logoutIfReloginRequiredWithToken(prevPlatform, platform.platform)
      }
      this.selectedIcon = platform.iconUrl || this.selectedIcon
      this.selectedAreaCode = platform.areaCode || this.selectedAreaCode
      this.GET_ICONURL = platform.iconUrl || this.GET_ICONURL
      this.GET_AREACODE = platform.areaCode || this.GET_AREACODE
      this.GET_COUNTRYNAME = platform.countryName || this.GET_COUNTRYNAME
      this.GET_COUNTRY = platform.country || this.GET_COUNTRY
      this.GET_PLATFORM = platform.platform || this.GET_PLATFORM
      this.GET_CURRENCYUNIT = platform.currencyUnit || this.GET_CURRENCYUNIT
      this.getCurrency = platform.currency || this.getCurrency
      safeSetStorageItem(localStorage, 'areaCode', platform.areaCode)
      safeSetStorageItem(localStorage, 'iconUrl', platform.iconUrl)
      safeSetStorageItem(localStorage, 'currency', platform.currency)
      safeSetStorageItem(localStorage, 'currencyUnit', platform.currencyUnit)
      safeSetStorageItem(localStorage, 'platform', platform.platform)
      safeSetStorageItem(localStorage, 'defaultLanguage', platform.defaultLanguage)
      safeSetStorageItem(localStorage, 'countryName', platform.countryName)
      safeSetStorageItem(localStorage, 'country', platform.country)
      this.showCountryDrop = false
      // Reload to apply the new language
      setTimeout(() => {
        reloadLocationSafely()
      }, 200)
    },
    goToActive() {
      this.$jumpTo('/activityCooperate')
    },
    getError3(v) {
      // 修改2：只保留数字，限制最大长度13位
      this.account = v.replace(/\D/g, '').slice(0, 13)

      // 修改3：注册页验证账号长度
      if (this.selectIndex === 1) {
        if (this.account.length === 0) {
          this.vError1 = ''
        } else if (this.account.length < 8 || this.account.length > 13) {
          this.vError1 = this.$lang.common_txt369 // 可替换为对应的$lang变量
        } else {
          this.vError1 = ''
        }
      }
    },
    getError(v) {
      if (this.selectIndex === 1) {
        if (v.length === 0) {
          this.vError2 = ''
        } else if (v.length > 16 || v.length < 6) {
          this.vError2 = this.$lang.login_txt17
        } else {
          this.vError2 = ''
        }
      }
    },
    getError2(v) {
      if (this.selectIndex === 1) {
        if (v.length === 0) {
          this.vError3 = ''
        } else if (v !== this.passwd) {
          this.vError3 = this.$lang.login_txt18
        } else {
          this.vError3 = ''
        }
      }
    },
    getCaptchaError(v) {
      if (this.selectIndex === 1 && this.isGhsCurrency) {
        if (!v) {
          this.vErrorCaptcha = ''
        } else {
          this.vErrorCaptcha = ''
        }
      }
    },
    startCaptchaCountdown() {
      this.captchaCountdown = 60
      if (this.captchaTimer) {
        clearInterval(this.captchaTimer)
      }
      this.captchaTimer = setInterval(() => {
        if (this.captchaCountdown > 0) {
          this.captchaCountdown -= 1
        } else {
          clearInterval(this.captchaTimer)
          this.captchaTimer = null
        }
      }, 1000)
    },
    clearCaptchaState() {
      this.captcha = ''
      this.vErrorCaptcha = ''
      this.captchaCountdown = 0
      this.isCaptchaSending = false
      if (this.captchaTimer) {
        clearInterval(this.captchaTimer)
        this.captchaTimer = null
      }
    },
    isCaptchaDeliveryConfirmed(data) {
      const layers = []
      const seen = []
      const visit = (source, depth = 0) => {
        if (!source || typeof source !== 'object' || Array.isArray(source) || depth > 4 || seen.indexOf(source) !== -1) return
        seen.push(source)
        layers.push(source)
        ;['content', 'data', 'body', 'payload', 'extra', 'page'].forEach(key => visit(source[key], depth + 1))
      }
      visit(data)

      const noDelivery = layers.some(source => {
        const delivery = safeString(source.delivery).toLowerCase()
        const sent = safeString(source.sent).toLowerCase()
        const codeSent = safeString(source.codeSent).toLowerCase()
        return source.localFallback === true ||
          safeString(source.localFallback).toLowerCase() === 'true' ||
          delivery === 'local_fallback' ||
          delivery === 'local-fallback' ||
          sent === 'false' ||
          sent === '0' ||
          codeSent === 'false' ||
          codeSent === '0'
      })
      if (noDelivery) return false
      return true
    },
    async sendCaptcha() {
      if (this.selectIndex !== 1 || !this.isGhsCurrency || !this.canSendCaptcha) {
        return
      }
      if (!this.account) {
        this.vError1 = this.$lang.login_txt19
        return
      }
      if (!/^\d{8,13}$/.test(this.account)) {
        this.vError1 = this.$lang.common_txt369
        return
      }
      this.vError1 = ''
      this.isCaptchaSending = true
      try {
        const data = await GetCaptcha({
          areaCode: this.currentAreaCode(),
          phoneNo: this.account,
          captchaType: 'register'
        })
        if (isOkResponse(data) && !isNeedLogin(data) && this.isCaptchaDeliveryConfirmed(data)) {
          this.startCaptchaCountdown()
        } else {
          this.$toast({
            message: failMessage(data, this.$lang.login_captcha_failed || this.$lang.network_error || 'Network error'),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: failMessage(e, this.$lang.network_error || 'Network error'),
          icon: 'cross'
        })
      } finally {
        this.isCaptchaSending = false
      }
    },
    // 用户通过了验证
    success() {
      this.isShow = false // 通过验证后，需要手动隐藏模态框
      this.Register()
    },
    // 用户点击遮罩层，应该关闭模态框
    close2() {
      this.isShow = false
    },
    logClose() {
      this.visible = false
      this.account = ''
      this.passwd = ''
      this.conPasswd = ''
      this.vError1 = ''
      this.vError2 = ''
      this.vError3 = ''
      this.clearCaptchaState()
      this.isShowMm = false
      this.isShowMm2 = false
    },
    selectTab(i) {
      this.selectIndex = i
      this.vError1 = ''
      this.vError2 = ''
      this.vError3 = ''
      this.account = ''
      this.passwd = ''
      this.conPasswd = ''
      this.clearCaptchaState()
    },
    gotoPrivacy() {
      this.$jumpTo('/privacy')
    },
    isLoginRegister() {
      this.isLogin = !this.isLogin
    },
    // 点击遮罩层时触发
    handleClickOverlay() {
      this.$emit('click-overlay')
    },
    // 弹窗关闭时触发
    handleClose() {
      this.$emit('close')
    },
    async GetIsFbReport() {
      const localStorage = getLocalStorage()
      try {
        const data = await GetIsFbReport({
          inviteCode: safeGetStorageItem(localStorage, 'id')
        })
        return safeTrackCompleteRegistration(this, data)
      } catch (e) {
        return false
      }
    },
    async Register() {
      const localStorage = getLocalStorage()
      const inviteCode = safeGetStorageItem(localStorage, 'id')
      const params = {
        account: this.account,
        passwd: md5(this.passwd),
        loginType: 'account',
        areaCode: this.currentAreaCode(),
        phoneNo: this.account,
        email: '',
        currency: this.currentCurrency(),
        platform: this.currentPlatform()
      }
      if (this.isGhsCurrency) {
        params.captcha = this.captcha
      }
      if (inviteCode) {
        params.id = inviteCode
        params.inviteCode = inviteCode
      }
      const fbExpand = safeGetStorageItem(localStorage, 'fbExpand')
      if (fbExpand) {
        params.fbExpand = fbExpand
      }
      this.submitting = true
      try {
        const data = await Register(params)
        const token = accessTokenOf(data)
        if (isOkResponse(data) && token) {
          this.visible = false
          safeSetStorageItem(localStorage, 'token', token)
          safeSetStorageItem(localStorage, 'isRegister', 'isRegister')
          await this.GetIsFbReport()
          this.finishLoginRedirect()
        } else {
          this.$toast({
            message: failMessage(data, this.$lang.login_txt20 || 'Registration failed'),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: failMessage(e, this.$lang.network_error || 'Network error'),
          icon: 'cross'
        })
      } finally {
        this.submitting = false
      }
    },
    async Login() {
      const localStorage = getLocalStorage()
      this.submitting = true
      try {
        const data = await Login({
          account: this.account,
          areaCode: this.currentAreaCode(),
          passwd: md5(this.passwd),
          passwordHash: await asheLocalPasswordHash(this.account, this.passwd),
          loginType: 'account',
          currency: this.currentCurrency(),
          platform: this.currentPlatform()
        })
        const token = accessTokenOf(data)
        if (isOkResponse(data) && token) {
          this.visible = false
          safeSetStorageItem(localStorage, 'token', token)
          this.finishLoginRedirect()
        } else {
          this.$toast({
            message: failMessage(data, this.$lang.login_txt20 || 'Login failed'),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: failMessage(e, this.$lang.network_error || 'Network error'),
          icon: 'cross'
        })
      } finally {
        this.submitting = false
      }
    },
    // 登录
    async LoginBtn() {
      if (this.submitting) return
      // 修改5：更新账号验证规则
      if (!this.account) {
        this.vError1 = this.$lang.login_txt19
      } else if (!/^\d{8,13}$/.test(this.account)) {
        this.vError1 = this.$lang.common_txt369 // 可替换为对应的$lang变量
      } else {
        this.vError1 = ''
      }

      if (!this.passwd) {
        this.vError2 = this.$lang.login_txt19
      } else if (this.passwd.length > 16 || this.passwd.length < 6) {
        this.vError2 = this.$lang.login_txt21
      } else {
        this.vError2 = ''
      }

      if (this.selectIndex === 1) {
        if (!this.conPasswd) {
          this.vError3 = this.$lang.login_txt19
        } else if (this.conPasswd !== this.passwd) {
          this.vError3 = this.$lang.login_txt19
        } else {
          this.vError3 = ''
        }
      }

      if (this.selectIndex === 1 && this.isGhsCurrency) {
        if (!this.captcha) {
          this.vErrorCaptcha = this.$lang.login_txt19
        } else {
          this.vErrorCaptcha = ''
        }
      } else {
        this.vErrorCaptcha = ''
      }

      if (!this.agree && this.selectIndex === 1) {
        this.$toast({
          message: this.$lang.login_txt22,
          icon: 'info',
          className: 'toastIndex' // 给toast添加类名
        })
        return
      }

      // 修改6：更新提交条件
      if (
        this.selectIndex === 1 &&
        !this.vError1 &&
        !this.vError2 &&
        !this.vError3 &&
        (!this.isGhsCurrency || !this.vErrorCaptcha) &&
        this.agree
      ) {
        await this.Register()
      } else if (this.selectIndex === 0 && !this.vError1 && !this.vError2) {
        await this.Login()
      }
    },
    // Google Login: Step 1 - get auth URL and redirect
    async handleGoogleLogin() {
      this.googleLoading = true
      try {
        const sessionStorage = getSessionStorage()
        const localStorage = getLocalStorage()
        const toUrl = googleCallbackRedirectUri()
        if (!toUrl) {
          this.$toast({
            message: this.$lang.google_login_url_failed || 'Google login is not configured',
            icon: 'cross'
          })
          return
        }
        const redirect = this.postLoginRedirectTarget()
        const data = await GetGoogleAuthorizingUrl({
          toUrl: toUrl,
          redirectUri: toUrl,
          isWap: true
        })
        const redirectUri = googleRedirectUrl(data)
        if (isOkResponse(data) && redirectUri) {
          if (redirect) safeSetStorageItem(sessionStorage, 'otgame_postLoginRedirect', redirect)
          safeSetStorageItem(localStorage, 'googleToUrl', toUrl)
          safeSetStorageItem(localStorage, 'googleRedirectUri', toUrl)
          redirectBrowserTo(redirectUri)
        } else {
          this.$toast({
            message: failMessage(data, this.$lang.google_login_url_failed || 'Google login is not configured'),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: failMessage(e, this.$lang.network_error || 'Network error'),
          icon: 'cross'
        })
      } finally {
        this.googleLoading = false
      }
    },
    // Google Login: Step 3 - register with phone
    async handleGoogleRegister() {
      const localStorage = getLocalStorage()
      if (!this.googlePhoneNo) {
        this.googleRegError = this.$lang.login_txt19 || 'Please enter the content'
        return
      }
      if (!/^\d{8,13}$/.test(this.googlePhoneNo)) {
        this.googleRegError = this.$lang.common_txt369 || 'The account number must consist of 8 to 13 digits only.'
        return
      }
      this.googleRegError = ''
      this.googleRegLoading = true
      try {
        const thirdUuid = safeString(this.googleThirdUuid || safeGetStorageItem(localStorage, 'googleThirdUuid'))
        if (!thirdUuid) {
          this.googleRegError = this.$lang.google_register_failed || 'Google registration failed'
          return
        }
        const params = {
          thirdUuid,
          phoneNo: this.googlePhoneNo,
          areaCode: this.currentAreaCode(),
          isWap: true
        }
        const inviteCode = safeGetStorageItem(localStorage, 'id')
        if (inviteCode) {
          params.id = inviteCode
        }
        const fbExpand = safeGetStorageItem(localStorage, 'fbExpand')
        if (fbExpand) {
          params.fbExpand = fbExpand
        }
        const data = await GoogleRegister(params)
        const token = accessTokenOf(data)
        if (isOkResponse(data) && token) {
          safeSetStorageItem(localStorage, 'token', token)
          safeRemoveStorageItem(localStorage, 'googleToUrl')
          safeRemoveStorageItem(localStorage, 'googleThirdUuid')
          this.showGoogleRegister = false
          safeSetStorageItem(localStorage, 'isRegister', 'isRegister')
          await this.GetIsFbReport()
          this.finishLoginRedirect()
        } else {
          this.googleRegError = failMessage(data, this.$lang.google_register_failed || 'Google registration failed')
        }
      } catch (e) {
        this.googleRegError = failMessage(e, this.$lang.network_error || 'Network error')
      } finally {
        this.googleRegLoading = false
      }
    },
    postLoginRedirectTarget() {
      const raw = safeString(this.$route && this.$route.query && this.$route.query.redirect)
      if (!raw) return ''
      try {
        const origin = getLocationOrigin()
        if (!origin) return ''
        const url = new URL(raw, origin)
        if (url.origin !== origin) return ''
        return `${url.pathname}${url.search}${url.hash}`
      } catch (e) {
        return ''
      }
    },
    cleanLoginRedirectQuery() {
      try {
        const href = getLocationHref()
        if (!href) return false
        const url = new URL(href)
        url.searchParams.delete('isValue')
        url.searchParams.delete('redirect')
        return replaceBrowserHistory(`${url.pathname}${url.search}${url.hash}`)
      } catch (e) {
        return false
      }
    },
    finishLoginRedirect() {
      const sessionStorage = getSessionStorage()
      this.visible = false
      const redirect = this.postLoginRedirectTarget() || safeGetStorageItem(sessionStorage, POST_LOGIN_REDIRECT_KEY)
      safeRemoveStorageItem(sessionStorage, 'otgame_postLoginRedirect')
      safeRemoveStorageItem(sessionStorage, POST_LOGIN_REDIRECT_KEY)
      this.$emit('close-key')
      if (redirect) {
        this.$router.replace(redirect).catch((error) => {
          if (isIgnoredLoginRedirectNavigationFailure(error)) return
          this.$toast({ message: failMessage(error, this.$lang.network_error || 'Network error'), icon: 'cross' })
        })
        return
      }
      this.cleanLoginRedirectQuery()
      setTimeout(() => {
        reloadLocationSafely()
      }, 200)
    }
  },
  beforeDestroy() {
    if (this.captchaTimer) {
      clearInterval(this.captchaTimer)
      this.captchaTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
@bg: #1a1d29;
@card: #252936;
@input-bg: #2a2f3e;
@neon: @brand;
@border: rgba(255, 255, 255, 0.08);
@muted: var(--vk-t2);

// ====== POPUP ======
.login-popup {
  overflow: hidden;
  width: 93%;
  max-width: 420px;
  background: @bg !important;
  border-radius: 16px !important;
  padding-bottom: 24px;
}

.login-popup__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  border: none;
  border-radius: 50%;
  cursor: pointer;
}

// ====== BANNER ======
/* VUKAVI 设计稿 banner(Montserrat 转曲渲染;源 SVG: src/assets/img/brand/vukavi_login_banner.svg) */
.login-popup__banner {
  position: relative;
  width: 100%;
  overflow: hidden;

  &-img {
    display: block;
    width: 100%;
    height: auto;
  }

  &-welcome {
    position: absolute;
    left: 20px;
    bottom: 14px;
    font-size: var(--vk-fs-2xs);
    font-weight: 700;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.75);
  }
}

// ====== TABS ======
.login-popup__tabs {
  display: flex;
  margin: 0 20px;
  border-bottom: 1px solid @border;
}

.login-popup__tab {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: var(--vk-fs-15);
  font-weight: 600;
  color: @muted;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;

  &--active {
    color: #ffffff;

    &::after {
      content: '';
      position: absolute;
      bottom: -1px;
      left: 20%;
      right: 20%;
      height: 3px;
      background: @neon;
      border-radius: 3px;
    }
  }
}

// ====== FORM ======
.login-popup__form {
  padding: 20px;
}

.login-popup__field-row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.login-popup__field {
  margin-bottom: 4px;
}

.login-popup__area-code {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 10px;
  height: 46px;
  background: @input-bg;
  border: 1.5px solid @border;
  border-radius: 10px;
  cursor: pointer;
  flex-shrink: 0;
  position: relative;

  &-text {
    color: #ffffff;
    font-size: var(--vk-fs-sm);
    font-weight: 600;
    white-space: nowrap;
  }
}

// ====== DROPDOWN ======
.login-popup__dropdown {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  z-index: 100;
  background: #2a2f3e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);

  &-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: var(--vk-fs-sm);
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background: rgba(255, 90, 31, 0.1);
    }
  }

  &-code {
    margin-left: auto;
    color: @neon;
    font-weight: 600;
    font-size: var(--vk-fs-xs);
  }
}

.login-popup__input {
  height: 46px;
  background: @input-bg !important;
  border: 1.5px solid @border !important;
  border-radius: 10px !important;
  color: #ffffff;
  font-size: var(--vk-fs-base);
  transition: border-color 0.2s;

  &--focus {
    border-color: @neon !important;
  }

  &--error {
    border-color: var(--vk-danger) !important;
  }

  ::v-deep .van-field__label {
    color: #ffffff;
    width: auto;
    margin-right: 8px;
  }

  ::v-deep .van-field__control {
    color: #ffffff;
  }

  ::v-deep .van-field__control::placeholder {
    color: var(--vk-t3);
  }
}

.login-popup__captcha-send {
  color: @neon;
  font-size: var(--vk-fs-base);
  font-weight: 600;
  cursor: pointer;
  user-select: none;

  &--disabled {
    color: var(--vk-t3);
    cursor: not-allowed;
  }
}

.login-popup__error {
  color: var(--vk-danger);
  font-size: var(--vk-fs-xs);
  padding: 4px 4px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}

// ====== SUBMIT ======
.login-popup__submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 24px;
  background: linear-gradient(135deg, @neon 0%, #ff8a3d 100%);
  color: @bg;
  font-size: var(--vk-fs-md);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  margin-top: 12px;
  box-shadow: 0 4px 16px rgba(255, 90, 31, 0.3);
  transition: transform 0.1s, opacity 0.2s;

  &:active {
    transform: scale(0.97);
  }

  &--disabled {
    background: #3a3f4e;
    color: var(--vk-t3);
    box-shadow: none;
    cursor: not-allowed;
  }
}

// ====== AGREE ======
.login-popup__agree {
  margin-top: 16px;

  &-text {
    font-size: var(--vk-fs-xs);
    color: @muted;
    line-height: 1.4;
  }

  ::v-deep .van-checkbox__icon .van-icon {
    border-radius: 3px;
    border-color: @neon;
  }

  ::v-deep .van-checkbox__label {
    margin-left: 6px;
    line-height: 1.4;
  }
}

// ====== 负责任博彩尾注(合规)======
.login-popup__responsible {
  margin-top: 16px;
  text-align: center;
  font-size: var(--vk-fs-2xs);
  color: var(--vk-t3);
  letter-spacing: 0.02em;
}

// ====== DIVIDER ======
.login-popup__divider {
  display: flex;
  align-items: center;
  margin: 20px 0 16px;

  &-line {
    flex: 1;
    height: 1px;
    background: @border;
  }

  &-text {
    color: var(--vk-t3);
    font-size: var(--vk-fs-xs);
    padding: 0 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
}

// ====== GOOGLE ======
.login-popup__google {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #ffffff;
  border: none;
  border-radius: 24px;
  font-size: var(--vk-fs-base);
  font-weight: 600;
  color: #333333;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

// ====== GOOGLE REG POPUP ======
.google-reg-popup {
  width: 93%;
  max-width: 420px;
  background: @bg !important;
  border-radius: 16px !important;
  padding: 24px 20px;
}

.google-reg {
  &__title {
    color: @neon;
    font-size: var(--vk-fs-lg);
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  }
}

// ====== OVERRIDES ======
::v-deep .van-popup__close-icon {
  color: #ffffff;
  font-size: var(--vk-fs-xl);
}

.toastIndex {
  z-index: 99999;
}

@media (min-width: 769px) {
  .login-popup {
    width: 400px !important;
  }
  .google-reg-popup {
    width: 400px !important;
  }
}
</style>
